// Module-level singleton — bypasses React state for R3F useFrame reads.
// SphereCorrectionOverlay writes directly; FadingDomes reads every frame.

export type SphereCorrectionMode = "roll" | "pitch" | "northOffset" | "yaw";

const sphereCorrectionLive: {
  active: boolean;
  mode: SphereCorrectionMode;
  roll: number;
  pitch: number;
  yaw: number;
  initialYaw: number;
  /** Always reflects the effective dome rotation (live or from scene). Updated by FadingDomes every frame. */
  current: { pitch: number; yaw: number; roll: number };
  /** Set by ViewerPage; called from overlay to re-center camera vertically */
  centerCamera: (() => void) | null;
} = {
  active: false,
  mode: "roll",
  roll: 0,
  pitch: 0,
  yaw: 0,
  initialYaw: 0,
  current: { pitch: 0, yaw: 0, roll: 0 },
  centerCamera: null,
};

export default sphereCorrectionLive;
